<template>
  <div>
    <div class="event-header">
      <div class="event-type">
        <i
          class="el-icon-user"
          :style="{color: 'red'}"
        />
        <span class="event-type-text">Failed Login</span>
        <el-tag
          :type="CardFunctions.getStatusType(event.status)"
          size="mini"
        >
          {{ event.status || '-' }}
        </el-tag>
      </div>
      <span class="event-time">
        <i class="el-icon-time" /> {{ CardFunctions.formatDate(event.created_at) }}
      </span>
    </div>

    <div class="event-resource">
      <div class="resource-name">
        {{ event.resource.name_full }}
      </div>
      <div class="resource-id">
        User: {{ event.resource.uuid }}
      </div>
    </div>

    <div
      v-if="event.data && Object.keys(event.data).length > 0"
      class="event-data"
    >
      <div
        v-for="(value, key) in event.data"
        :key="key"
        class="data-item"
      >
        <span class="data-label">{{ CardFunctions.formatKey(key) }}:</span>
        <span>{{ CardFunctions.formatValue(value) }}</span>
      </div>
    </div>

    <div class="event-actions">
      <el-button
        size="mini"
        type="text"
        @click="$emit('view-details', event)"
      >
        View Details
      </el-button>
      <el-button
        size="mini"
        type="text"
        @click="$emit('view-resource', event)"
      >
        Open {{ event.resource.type }}
      </el-button>
    </div>
  </div>
</template>
<script>
import CardFunctions from '@/components/Application/Feed/Cards/CardFunctions'

export default {
  name: 'FailedLoginCard',
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  computed: {
    CardFunctions () {
      return CardFunctions
    }
  }
}
</script>
